//@flow
import {
  Actions
} from 'app/actions';
import {
  // findGetParameter
} from 'lib/Helpers';


import * as React from 'react';
import ScrollToTop from 'lib/scroll-to-top';
import {
  Container
} from 'flux/utils';

import App from './app';

import {
  Validator,
  authStore
} from 'lib/idd-auth'

import {
  CookiesProvider,
  Cookies
} from 'react-cookie';

import {
  BrowserRouter as RouterContext
} from 'react-router-dom'

class AppContainer extends React.Component<*> {

  static getStores() {
    return [authStore];
  }

  static calculateState(prevState) {
    return {
      authStore: authStore.getState()
    };
  }

  loggedIn = false;
  componentWillMount() {
    this.loggedIn = Validator.isLoggedIn();
  }
  componentWillUpdate() {
    this.loggedIn = Validator.isLoggedIn();
  }



  render() {
    if (!this.loggedIn) return null;
    //////////////////
    // let brand = null;
    // brand = findGetParameter('b')
    const cookies = new Cookies();
    const brandCookie = cookies.get('brand')
    if (brandCookie) {
      // console.log("Found brand in cookie: ", brandCookie);
      Actions.setBrandFocus(brandCookie.id ? { id: brandCookie.id, label: brandCookie.name } : null)
    }
    //////////////////


    return <CookiesProvider>
      <RouterContext>
        <ScrollToTop>
          <App />
        </ScrollToTop>
      </RouterContext>
    </CookiesProvider>;
  }
}
export default Container.create(AppContainer);